<script setup>
import { computed, h } from 'vue';
import { WhatsappIcon } from '@hugeicons/core-free-icons';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import HugeIcon from 'dashboard/components-next/icon/HugeIcon.vue';
import SettingsSectionLayout from '../components/SettingsSectionLayout.vue';

const { t } = useI18n();
const { accountScopedRoute } = useAccount();
const settingsIcon = icon =>
  h(HugeIcon, {
    icon,
    size: 20,
    class: 'shrink-0',
  });

const sections = computed(() => [
  {
    name: 'billing_settings_section',
    label: t('GENERAL_SETTINGS.SIDEBAR.GROUP_BILLING'),
    children: [
      {
        name: 'general_settings_whatsapp_fees',
        label: t('GENERAL_SETTINGS.SIDEBAR.WHATSAPP_FEES'),
        icon: settingsIcon(WhatsappIcon),
        to: accountScopedRoute('general_settings_whatsapp_fees'),
      },
      {
        name: 'general_settings_billing',
        label: t('GENERAL_SETTINGS.SIDEBAR.BILLING'),
        icon: 'i-lucide-credit-card',
        to: accountScopedRoute('general_settings_billing'),
      },
      {
        name: 'general_settings_ai_billing',
        label: t('GENERAL_SETTINGS.SIDEBAR.AI_BILLING'),
        icon: 'i-lucide-sparkles',
        to: accountScopedRoute('general_settings_ai_billing'),
      },
    ],
  },
]);
</script>

<template>
  <SettingsSectionLayout
    :title="t('SIDEBAR.BILLING')"
    :aria-label="t('SIDEBAR.BILLING')"
    :sections="sections"
  >
    <router-view />
  </SettingsSectionLayout>
</template>
